<template>
  <div>
    <div class="d-flex toolbar justify-content-between mb-4">
      <h4 class="text-color-4">Webhook</h4>
    </div>
    <div v-if="loading">
      <Spinner size="sm" />
    </div>
    <div v-else
         id="account-form">
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="handleFormSubmit">
          <div class="row">
            <div class="col-md-6 col-sm-12 px-5">
              <!-- Name -->
              <TextBox type="text"
                       id="webhook-url"
                       rules="required|webhookUrl"
                       :label="'Webhook URL'"
                       v-model="webhookSettingsForm.url" />

              <TextArea type="text"
                        id="webhook-headers"
                        :label="'ส่วนหัวของ Webhook ในรูปแบบ JSON'"
                        placeholder="ป้อนส่วนหัวของเว็บฮุคในรูปแบบ JSON"
                        v-model="webhookSettingsForm.headers"
                        rules="json"
                        :rows="4" />

              <!-- Submit & Cancel Buttons -->
              <Button type="submit"
                      variant="primary"
                      custom_class="btn-block mr-4"
                      :disabled="invalid"
                      :loading="formLoading">{{ $t("general.update") }}</Button>
            </div>
            <div class="col-md-6">
              <div class="alert alert-info text-md">
                โปรดเยี่ยมชม URL นี้เพื่อเรียนรู้เพิ่มเติมเกี่ยวกับข้อมูลที่ได้รับผ่านเว็บฮุค::
                <br />
                <a href="https://developer.proship.me/resources/webhook"
                   style="color: black"
                   target="_blank">https://developer.proship.me/resources/webhook</a>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>

  </div>
</template>

<script>
import Button from "@/components/core/Button";
import NumberField from "@/components/core/NumberField";
import Card from "@/components/core/Card";
import TextBox from "@/components/core/TextBox";
import PhoneNumber from "@/components/derived/PhoneNumber";
import VatField from "@/components/derived/VatField";
import SmartAddress from "@/components/derived/SmartAddress";
import Spinner from "@/components/core/Spinner";
import TextArea from "@/components/core/TextArea.vue";

export default {
  name: "SellerSettingsAccount",
  components: {
    Card,
    TextBox,
    PhoneNumber,
    Spinner,
    Button,
    SmartAddress,
    NumberField,
    VatField,
    TextArea
  },

  data() {
    return {
      loading: false,
      formLoading: false,
      error: false,
      webhookSettingsForm: null,
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    initForm() {
      return {
        url: null,
        headers: null,
      };
    },

    fetchData() {
      this.loading = true;
      this.$store.dispatch("settings/fetchWebhook", {
        callback: (status, data) => {
          if (status) {
            this.webhookSettingsForm = data ? data : this.initForm();
          }
          this.loading = false;
        },
      });
    },

    handleFormSubmit() {
      this.formLoading = true;
      this.$store.dispatch("settings/updateWebhook", {
        webhook: this.webhookSettingsForm,
        callback: (status) => (this.formLoading = false),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.setting__header {
  font-weight: bold;
  font-size: 18px;
}

.setting__description {
  font-weight: thin;
  font-size: 13px;
}

.setting {
  &.--inline {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &.--table {
    .setting__text {
      margin-bottom: 20px;
    }
  }

  margin-bottom: 30px;
}

.settings-wrapper {
  margin-top: 24px;
}

.setting-status-tag {
  text-transform: uppercase;

  font-weight: bold;
  font-size: 12px;
  padding: 5px 10px;
  border-radius: 2px;
  text-align: center;
  width: 68px;
  height: 29px;

  &.--warning {
    background-color: #ffc107;
    color: black;
  }

  &.--success {
    background-color: #28a745;
    color: white;
  }

  &.--danger {
    background-color: #dc3545;
    color: white;
  }

  &.--info {
    background-color: #007bff;
    color: white;
  }
}
</style>